import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../../types/shared/UUID';
import { useGetEmdAmount } from './hooks/useGetEmdAmount';
import {
  AccessCodeResponse,
  sortBySentAt,
  useListActiveOrderEmdAccessLinksQuery,
} from '../../../../../../API/order/payments/EmdAccessCodeApi';
import _ from 'lodash';
import { PreviousAccessCodeAndResend } from './PreviousAccessCodeAndResend';

export const AcornAccessCodeDisplayAndButtons: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { emdAmount } = useGetEmdAmount();
  const { data: accessCodeResponses = [] } = useListActiveOrderEmdAccessLinksQuery(orderId, { skip: !emdAmount });
  const sortedAccessCodeResponses = useMemo(() => accessCodeResponses.toSorted(sortBySentAt), [accessCodeResponses]);

  if (_(sortedAccessCodeResponses).isEmpty()) {
    return (
      <button onClick={onClick} className="text-xs font-bold text-blue-900">
        Create and send access code ›
      </button>
    );
  }

  return (
    <>
      {sortedAccessCodeResponses.map((accessCodeResponse: AccessCodeResponse) => (
        <PreviousAccessCodeAndResend
          key={accessCodeResponse.id}
          accessCodeResponse={accessCodeResponse}
          onClick={onClick}
        />
      ))}
    </>
  );
};
